import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2747a622"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-tracker-record" }
const _hoisted_2 = { class: "task-time-tracker-record__current-time" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "task-time-tracker-record__date"
}
const _hoisted_5 = { class: "task-time-tracker-record__time" }
const _hoisted_6 = {
  key: 0,
  class: "task-time-tracker-record__controls"
}

import { computed, PropType } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
} from 'tir-components';
import { TrashIcon, PencilSquareIcon } from 'tir-style-system/icons/outline';
import { TaskTimeRecordModel } from './models';
import dateTransform from 'tir-pm-date-transform';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-tracker-record',
  props: {
  /**Запись таймера */
  record: {
    type: Object as PropType<TaskTimeRecordModel>,
    required: true,
  },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
},
  emits: ["onDelete", "onEdit"],
  setup(__props, { emit }) {

const props = __props;





const computedNameCompareFoto = computed(() => {
  if (!props.record.Performer) return;
  return (
    props.record.Performer.FirstName?.[0]?.toUpperCase() +
    props.record.Performer.LastName?.[0]?.toUpperCase()
  );
});
/**Разрешено редактирование времени */
const allowEdit = computed(() => {
  const isCurrentUser = props.record?.Performer?.Id == CurrentUser.Id;
  const isToday = props.record?.DateEnd?.getDate() == new Date().getDate();
  const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

  return (isCurrentUser && isToday) || isOwner || props.userAccess.IsProjectAdmin;
});

/**Расчитать разницу */
const calculateTimeDifference = (date1: Date, date2: Date): { hours: number; minutes: number } => {
  // Получаем разницу в миллисекундах между двумя датами
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());

  // Переводим разницу в часы и минуты
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

  return { hours, minutes };
};

const dateEndStr = computed(() =>
  props.record.DateEnd ? dateTransform(props.record.DateEnd).format('DD.MM.YYYY') : undefined,
);
/**Строка с временм */
const timeStr = computed(() => {
  let str = '';
  const dateStartTime = dateTransform(props.record.DateStart).format('HH:mm');
  if (props.record.DateEnd) {
    const { hours, minutes } = calculateTimeDifference(
      props.record.DateStart,
      props.record.DateEnd,
    );
    str += `${dateStartTime}-${dateTransform(props.record.DateEnd).format(
      'HH:mm',
    )} (${`${hours}ч.`} ${`${minutes}мин.`})`;
  } else {
    str += dateStartTime;
  }

  return str;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.record.Performer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isRounded: "",
              isBordered: false,
              colorCode: __props.record.Performer.AvatarColor,
              imageLoadUrl: __props.record.Performer.Foto
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(computedNameCompareFoto.value), 1)
              ]),
              _: 1
            }, 8, ["colorCode", "imageLoadUrl"])
          ]))
        : _createCommentVNode("", true),
      (dateEndStr.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(dateEndStr.value) + ": ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(timeStr.value), 1)
    ]),
    (allowEdit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).LinkState,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onDelete')))
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(TrashIcon))
            ]),
            _: 1
          }, 8, ["size", "variant"]),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).LinkState,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onEdit')))
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(PencilSquareIcon))
            ]),
            _: 1
          }, 8, ["size", "variant"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})